(() => {
  const shadeIntentAvailability = (map, name, defaults) => {
    const shade = map?.colours?.find((item) => item.name === name);
    const available = (value, fallback) => {
      if (typeof value === 'boolean') return value;
      if (String(value).toLowerCase() === 'true') return true;
      if (String(value).toLowerCase() === 'false') return false;
      return fallback;
    };
    return {
      plano: available(shade?.plano_available, defaults.plano),
      powered: available(shade?.prescription_available, defaults.powered)
    };
  };

  const shadePowerPresentation = (map, name, defaults) => {
    const availability = shadeIntentAvailability(map, name, defaults);
    return {
      ...availability,
      planoOnly: availability.plano && !availability.powered,
      otherPowered: (map?.colours || []).some((shade) => shade.name !== name
        && shadeIntentAvailability(map, shade.name, defaults).powered)
    };
  };

  const toCdnWidth = (url, width) => {
    if (!url || !/^https?:\/\//.test(url)) return url || '';
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
  };

  const readMap = (root) => {
    if (root.__cityColourMap?.colours?.length) return root.__cityColourMap;
    const source = root.querySelector('[data-city-colour-map]');
    if (!source) return null;
    try {
      return JSON.parse(source.textContent || 'null');
    } catch (error) {
      return null;
    }
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const calculateContactLensSupply = ({ lensesPerBox, daysPerLens, daysPerMonth = 30, leftBoxes, rightBoxes, sharedBoxes = false }) => {
    const lenses = Number(lensesPerBox || 0);
    const days = Number(daysPerLens || 0);
    const left = Number(leftBoxes || 0);
    const right = Number(rightBoxes || 0);
    const divisor = Number(daysPerMonth || 30);
    const monthsFor = (boxes) => boxes > 0 && lenses > 0 && days > 0 ? boxes * lenses * days / divisor : 0;
    return {
      lensesPerBox: lenses,
      daysPerLens: days,
      leftBoxes: left,
      rightBoxes: right,
      totalBoxes: sharedBoxes ? left : left + right,
      totalLenses: (sharedBoxes ? left : left + right) * lenses,
      leftMonths: sharedBoxes ? monthsFor(left) / 2 : monthsFor(left),
      rightMonths: sharedBoxes ? monthsFor(left) / 2 : monthsFor(right),
      sharedBoxes
    };
  };
  window.CityContactLensSupply = window.CityContactLensSupply || {};
  window.CityContactLensSupply.calculate = calculateContactLensSupply;
  const purchaseSupplyFromForm = (form, sharedBoxes = form?.__cityContactSharedBoxes || false) => {
    const component = form?.querySelector('[data-city-contact-purchase-options]');
    if (!component) return null;
    let data = component.__cityPlanData;
    if (!data) {
      try { data = JSON.parse(component.querySelector('[data-city-selling-plan-data]').textContent); }
      catch (error) { return null; }
      component.__cityPlanData = data;
    }
    const variants = Object.values(data.variants || {});
    let variant = data.variants[String(form.querySelector('input.product-variant-id[name=id]')?.value || '')];
    const info = form.closest('product-info');
    const lensType = info?.querySelector('[data-city-lens-type-option]');
    const plano = form?.dataset?.cityLensIntent === 'plano';
    if (variant && lensType) {
      const index = Number(lensType.dataset.optionIndex);
      const targetType = plano && variants.some(candidate => candidate.options[index] === 'Plano') ? 'Plano' : 'Standard';
      variant = variants.find(candidate => candidate.options[index] === targetType
        && candidate.options.every((value, position) => position === index || value === variant.options[position])
        && candidate.available && candidate.price === variant.price);
    }
    if (!variant) return null;
    const schedule = String(variant.wearSchedule || '').toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
    const days = { daily: 1, 'daily disposable': 1, weekly: 7, fortnightly: 14, monthly: 30, 'six monthly': 180, '6 monthly': 180 }[schedule] || 0;
    const leftBoxes = Number(form.querySelector('select[name="properties[Quantity Left]"]')?.value || 0);
    const rightBoxes = plano ? 0 : Number(form.querySelector('select[name="properties[Quantity Right]"]')?.value || 0);
    if (plano) sharedBoxes = true;
    form.__cityContactSharedBoxes = sharedBoxes;
    return {
      ...calculateContactLensSupply({ lensesPerBox: variant.lensesPerBox, daysPerLens: days, daysPerMonth: schedule === 'fortnightly' ? 28 : 30, leftBoxes, rightBoxes, sharedBoxes }),
      variantId: variant.id,
      unitPriceCents: variant.price,
      available: variant.available
    };
  };
  window.CityContactLensSupply.fromForm = purchaseSupplyFromForm;
  const emitPurchaseSupply = (form, sharedBoxes = false) => {
    const state = purchaseSupplyFromForm(form, sharedBoxes);
    if (state) form.dispatchEvent(new CustomEvent('city:contact-lens-order-state', { detail: state }));
    return state;
  };

  const selectedColourDiameter = (root) => {
    const colourMap = readMap(root);
    const selectedName = root?.querySelector('.city-colour-picker__option.is-selected')?.dataset.colourName || '';
    return colourMap?.colours?.find((colour) => colour.name === selectedName)?.diameter || '';
  };

  const syncLensParameterProperties = (root, formData) => {
    if (!root) return;
    const fixed = root.querySelector('[data-city-clear-fixed-parameters]');
    const shadeDiameter = selectedColourDiameter(root);
    const fallbacks = { 'Base Curve': fixed?.dataset.cityFixedBaseCurve || '', Diameter: shadeDiameter || fixed?.dataset.cityFixedDiameter || '' };
    Object.entries(fallbacks).forEach(([key, fallback]) => {
      ['Left', 'Right'].forEach((side) => {
        const name = `properties[${key} ${side}]`;
        const field = root.querySelector(`[name="${name}"]`);
        const value = String((key === 'Diameter' && shadeDiameter) || field?.value || fallback || '').trim();
        if (!value) return;
        if (field) { field.value = value; field.setAttribute('value', value); }
        if (formData && !field?.disabled) formData.set(name, value);
      });
    });
  };

  const bindLensParameterFormData = (root, productForm) => {
    if (!root || !productForm || root.dataset.cityLensParameterFormDataReady === 'true') return;
    root.dataset.cityLensParameterFormDataReady = 'true';
    productForm.addEventListener('formdata', (event) => syncLensParameterProperties(root, event.formData));
  };

  const readLensParameterLine = (root) => {
    if (!root) return '';
    syncLensParameterProperties(root);
    const fixed = root.querySelector('[data-city-clear-fixed-parameters]');
    const samePrescription = Boolean(root.querySelector('#same')?.checked);
    const readEyeValue = (key, side) => String(root.querySelector(`[name="properties[${key} ${side}]"]`)?.value || '').trim();
    const formatParameter = (key, label, fallback) => {
      const left = readEyeValue(key, 'Left') || String(fallback || '').trim();
      const right = samePrescription ? left : (readEyeValue(key, 'Right') || String(fallback || '').trim());
      const hasField = Boolean(root.querySelector(`[name="properties[${key} Left]"]`));
      if (!left && !right) return hasField ? `Select ${label}` : '';
      if (left && right && left !== right) return `${label} L ${left} / R ${right}`;
      return `${label} ${left || right}`;
    };
    const baseCurve = formatParameter('Base Curve', 'BC', fixed?.dataset.cityFixedBaseCurve);
    let diameter = formatParameter('Diameter', 'DIA', fixed?.dataset.cityFixedDiameter);
    if (diameter && !/select dia/i.test(diameter) && !/mm$/i.test(diameter)) diameter += ' mm';
    return [baseCurve, diameter].filter(Boolean).join(' · ');
  };

  const parameterSummaryHtml = (root) => {
    const line = readLensParameterLine(root);
    return line ? `<small class="city-contact-order-summary__parameters">${escapeHtml(line)}</small>` : '';
  };

  const readGeneratedMap = (root) => {
    if (root.__cityGeneratedColourMap) return root.__cityGeneratedColourMap;
    const source = root.querySelector('[data-city-colour-generated-map]');
    if (!source) return null;
    try {
      root.__cityGeneratedColourMap = JSON.parse(source.textContent || 'null');
      return root.__cityGeneratedColourMap;
    } catch (error) {
      return null;
    }
  };

  const setupResponsivePdpOrder = ({ product, mediaWrapper, toolbox, gallery }, root, productForm) => {
    if (!product || !mediaWrapper || !toolbox || !gallery || !root || !productForm) return;
    if (product.__cityColourResponsiveOrder) {
      product.__cityColourResponsiveOrder.apply();
      return;
    }

    const infoContainer = product.querySelector('.product__info-container');
    const purchaseBlock = productForm.closest('product-form');
    const mediaBlock = toolbox.closest('#magic-zoom-plus-block') || toolbox.parentElement;
    if (!infoContainer || !purchaseBlock || !mediaBlock) return;

    const headerSelectors = [
      ':scope > .product__text.caption-with-letter-spacing',
      ':scope > .product__title',
      ':scope > .shopify-app-block',
      ':scope > .city-review-fallback',
      ':scope > [id^="price-"]',
      ':scope > .product-contact-badges'
    ];
    const headerNodes = headerSelectors.map((selector) => infoContainer.querySelector(selector)).filter(Boolean);
    if (!headerNodes.length) return;

    const mobileHeader = document.createElement('div');
    mobileHeader.className = 'city-colour-mobile-header';
    mobileHeader.dataset.cityColourMobileHeader = '';
    mediaWrapper.insertBefore(mobileHeader, mediaBlock);

    const headerAnchors = headerNodes.map((node) => {
      const anchor = document.createComment('city-colour-mobile-header-anchor');
      node.parentNode.insertBefore(anchor, node);
      return { node, anchor };
    });
    const galleryAnchor = document.createComment('city-colour-gallery-anchor');
    gallery.parentNode.insertBefore(galleryAnchor, gallery);
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const apply = () => {
      if (mobileQuery.matches) {
        headerNodes.forEach((node) => mobileHeader.appendChild(node));
        purchaseBlock.insertAdjacentElement('afterend', gallery);
        product.classList.add('product--colour-contact-mobile-order');
      } else {
        headerAnchors.forEach(({ node, anchor }) => anchor.parentNode?.insertBefore(node, anchor.nextSibling));
        galleryAnchor.parentNode?.insertBefore(gallery, galleryAnchor.nextSibling);
        product.classList.remove('product--colour-contact-mobile-order');
      }
      const price = headerNodes.find((node) => node.matches('[id^="price-"]'));
      const placement = product.querySelector('square-placement[data-page-type="product"]:not([data-safestyle-afterpay])');
      if (price && placement && price.nextElementSibling !== placement) price.insertAdjacentElement('afterend', placement);
    };

    mobileQuery.addEventListener?.('change', apply);
    product.__cityColourResponsiveOrder = { apply };
    apply();
  };

  const shadeButton = (root, name) => Array.from(root.querySelectorAll('.city-colour-picker__option'))
    .find((button) => button.dataset.colourName === name);

  const setupShadeSelector = (root, map) => {
    const picker = root.querySelector('.city-colour-picker');
    const heading = picker?.querySelector('.city-colour-picker__heading');
    const grid = picker?.querySelector('.city-colour-picker__grid');
    const colours = Array.isArray(map?.colours) ? map.colours : [];
    if (!picker || !heading || !grid || !colours.length) return;

    picker.classList.toggle('city-colour-picker--rail', colours.length > 4);

    let titleGroup = heading.querySelector('.city-colour-picker__title-group');
    if (!titleGroup) {
      const title = heading.querySelector(':scope > span');
      titleGroup = document.createElement('span');
      titleGroup.className = 'city-colour-picker__title-group';
      heading.insertBefore(titleGroup, title || heading.firstChild);
      if (title) titleGroup.appendChild(title);
    }
    let count = titleGroup.querySelector('.city-colour-picker__count');
    if (!count) {
      count = document.createElement('small');
      count.className = 'city-colour-picker__count';
      titleGroup.appendChild(count);
    }
    count.textContent = `${colours.length} ${colours.length === 1 ? 'colour' : 'colours'}`;

    let shell = picker.querySelector('.city-colour-picker__rail-shell');
    let previous = picker.querySelector('[data-city-colour-rail-previous]');
    let next = picker.querySelector('[data-city-colour-rail-next]');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'city-colour-picker__rail-shell';
      previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'city-colour-picker__rail-button city-colour-picker__rail-button--previous';
      previous.dataset.cityColourRailPrevious = '';
      previous.setAttribute('aria-label', 'Previous contact lens colours');
      previous.innerHTML = '&#8249;';
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'city-colour-picker__rail-button city-colour-picker__rail-button--next';
      next.dataset.cityColourRailNext = '';
      next.setAttribute('aria-label', 'Next contact lens colours');
      next.innerHTML = '&#8250;';
      grid.parentNode.insertBefore(shell, grid);
      shell.append(previous, grid, next);
    }

    const applyFocalPositions = () => {
      const byName = new Map(colours.map((colour) => [colour.name, colour]));
      grid.querySelectorAll('.city-colour-picker__option').forEach((button) => {
        const colour = byName.get(button.dataset.colourName) || {};
        const focal = colour.thumbnail_focal || colour.focal_position || '50% 56%';
        button.style.setProperty('--city-colour-thumbnail-position', focal);
      });
    };
    const updateControls = () => {
      const scrollable = grid.scrollWidth > grid.clientWidth + 4;
      picker.classList.toggle('is-scrollable', scrollable);
      previous.disabled = !scrollable || grid.scrollLeft <= 4;
      next.disabled = !scrollable || grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4;
    };
    const scrollSelectedIntoView = (selectedButton, behavior = 'smooth') => {
      const selected = selectedButton || grid.querySelector('.city-colour-picker__option.is-selected');
      if (!selected || grid.scrollWidth <= grid.clientWidth + 4) return;
      const target = selected.offsetLeft - Math.max(0, (grid.clientWidth - selected.offsetWidth) / 2);
      grid.scrollTo({ left: Math.max(0, target), behavior });
      window.setTimeout(updateControls, behavior === 'smooth' ? 350 : 0);
    };

    if (picker.dataset.cityColourRailReady !== 'true') {
      picker.dataset.cityColourRailReady = 'true';
      const moveRail = (direction) => {
        const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        const target = Math.max(0, Math.min(maxScroll, grid.scrollLeft + (direction * grid.clientWidth * 0.92)));
        grid.classList.add('is-arrow-scrolling');
        grid.scrollTo({ left: target, behavior: 'smooth' });
        window.setTimeout(() => {
          grid.classList.remove('is-arrow-scrolling');
          updateControls();
        }, 450);
      };
      previous.addEventListener('click', () => {
        moveRail(-1);
      });
      next.addEventListener('click', () => {
        moveRail(1);
      });
      grid.addEventListener('scroll', updateControls, { passive: true });
      window.ResizeObserver && new ResizeObserver(updateControls).observe(grid);
    }

    root.__cityColourScrollSelected = scrollSelectedIntoView;
    root.__cityColourUpdateRail = updateControls;
    [0, 120, 500].forEach((delay) => window.setTimeout(() => {
      applyFocalPositions();
      updateControls();
      if (delay === 500) scrollSelectedIntoView(null, 'auto');
    }, delay));
  };

  const showHeroEntry = (shell, index) => {
    let entries = [];
    try {
      entries = JSON.parse(shell.slides.dataset.cityColourEntries || '[]');
    } catch (error) {
      entries = [];
    }
    if (!entries.length || !shell.hero) return;
    const nextIndex = (index + entries.length) % entries.length;
    const entry = entries[nextIndex];
    shell.slides.dataset.cityColourEntryIndex = String(nextIndex);
    shell.hero.src = toCdnWidth(entry.src, 1400);
    shell.hero.alt = entry.alt || '';
    shell.hero.classList.toggle('is-pattern', Boolean(entry.pattern));
    shell.hero.classList.toggle('is-isolated-pattern', Boolean(entry.isolatedPattern));
    shell.hero.classList.toggle('is-compact-source', Boolean(entry.compactSource));
    ['on-eye', 'comparison', 'wider', 'packaging'].forEach((kind) => {
      shell.hero.classList.toggle(`is-${kind}`, entry.kind === kind);
    });
    shell.overlay.hidden = entry.showOverlay !== true;
    shell.gallery?.querySelectorAll('.city-colour-detail-card').forEach((card, cardIndex) => {
      card.classList.toggle('is-active', cardIndex === nextIndex);
      if (card.matches('button')) card.setAttribute('aria-pressed', cardIndex === nextIndex ? 'true' : 'false');
    });
  };

  const ensureVisualShell = (root) => {
    if (root.__cityColourVisualShell?.product?.isConnected) return root.__cityColourVisualShell;
    const product = root.closest('.product');
    const mediaWrapper = product?.querySelector('.product__media-wrapper');
    const slides = mediaWrapper?.querySelector('.MagicToolboxSlides');
    const toolbox = mediaWrapper?.querySelector('.MagicToolboxContainer');
    if (!product || !mediaWrapper || !slides || !toolbox) return null;

    product.classList.add('product--colour-contact');
    const referenceGallery = Boolean(readGeneratedMap(root));
    product.classList.toggle('product--colour-contact-reference', referenceGallery);

    let hero = slides.querySelector('[data-city-colour-hero-image]');
    if (referenceGallery && !hero) {
      hero = document.createElement('img');
      hero.className = 'city-colour-hero-image';
      hero.dataset.cityColourHeroImage = '';
      hero.alt = '';
      hero.decoding = 'async';
      slides.appendChild(hero);
    }

    let overlay = slides.querySelector('[data-city-colour-hero-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'city-colour-hero-overlay';
      overlay.dataset.cityColourHeroOverlay = '';
      overlay.innerHTML = `
        <div class="city-colour-hero-overlay__lens" aria-hidden="true"><img alt=""></div>
        <strong class="city-colour-hero-overlay__label"></strong>
      `;
      slides.appendChild(overlay);
    }

    let navigation = slides.querySelector('[data-city-colour-hero-navigation]');
    if (!navigation) {
      navigation = document.createElement('div');
      navigation.className = 'city-colour-hero-navigation';
      navigation.dataset.cityColourHeroNavigation = '';
      navigation.innerHTML = `
        <button type="button" data-city-colour-hero-previous aria-label="Previous colour">&#8249;</button>
        <button type="button" data-city-colour-hero-next aria-label="Next colour">&#8250;</button>
      `;
      slides.appendChild(navigation);
    }
    const moveColour = (direction) => {
      const buttons = Array.from(root.querySelectorAll('.city-colour-picker__option'));
      if (!buttons.length) return;
      const selected = buttons.findIndex((button) => button.classList.contains('is-selected'));
      const nextIndex = (Math.max(0, selected) + direction + buttons.length) % buttons.length;
      const alpineData = Array.isArray(root._x_dataStack)
        ? root._x_dataStack.find((item) => typeof item?.selectColourBoth === 'function')
        : null;
      if (alpineData) alpineData.selectColourBoth(buttons[nextIndex].dataset.colourName);
      else buttons[nextIndex].click();
      buttons[nextIndex].focus({ preventScroll: true });
    };
    const moveReferenceMedia = (direction) => {
      const current = Number(slides.dataset.cityColourEntryIndex || 0);
      showHeroEntry({ slides, hero, overlay, gallery }, current + direction);
    };
    if (referenceGallery && navigation.dataset.cityReferenceNavigationReady !== 'true') {
      navigation.dataset.cityReferenceNavigationReady = 'true';
      navigation.addEventListener('click', (event) => {
        const previous = event.target.closest('[data-city-colour-hero-previous]');
        const next = event.target.closest('[data-city-colour-hero-next]');
        if (!previous && !next) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        moveReferenceMedia(previous ? -1 : 1);
      }, true);
    } else if (!referenceGallery) {
      navigation.querySelector('[data-city-colour-hero-previous]').onclick = () => moveColour(-1);
      navigation.querySelector('[data-city-colour-hero-next]').onclick = () => moveColour(1);
    }

    let gallery = product.querySelector('[data-city-colour-detail-gallery]');
    if (!gallery) {
      gallery = document.createElement('section');
      gallery.className = 'city-colour-detail-gallery';
      gallery.dataset.cityColourDetailGallery = '';
      gallery.setAttribute('aria-live', 'polite');
      toolbox.insertAdjacentElement('afterend', gallery);
    }
    if (referenceGallery && gallery.dataset.cityReferenceGalleryReady !== 'true') {
      gallery.dataset.cityReferenceGalleryReady = 'true';
      gallery.addEventListener('click', (event) => {
        const card = event.target.closest('[data-city-colour-entry-index]');
        if (!card || !gallery.contains(card)) return;
        event.preventDefault();
        showHeroEntry({ slides, hero, overlay, gallery }, Number(card.dataset.cityColourEntryIndex || 0));
      }, true);
    }

    const colourField = root.querySelector('.city-colour-picker')?.closest('.product-form__input');
    colourField?.classList.add('city-colour-picker-field');
    if (colourField && root.firstElementChild !== colourField) {
      root.insertBefore(colourField, root.firstElementChild);
    }

    const info = root.closest('product-info');
    const variantPicker = info?.querySelector('variant-selects');
    const packOptionInput = variantPicker?.querySelector('input[type="radio"][name="Size"], input[type="radio"][name="Pack Size"]');
    const packOptionField = packOptionInput?.closest('.product-form__input')
      || Array.from(variantPicker?.querySelectorAll('.product-form__input') || []).find((field) => /^(size|pack size)$/i.test(field.querySelector('legend, .form__label')?.textContent.trim() || ''));
    const optionInputs = packOptionField ? Array.from(packOptionField.querySelectorAll('input[type="radio"]')) : [];
    const packValues = [...new Set(optionInputs.map((input) => input.value).filter(Boolean))];
    const isFixedPack = Boolean(variantPicker && packValues.length === 1);
    const isMultiPack = Boolean(variantPicker && packValues.length > 1);
    const productForm = root.closest('form') || info?.querySelector('product-form form');
    const purchaseScope = productForm || root;
    const buttons = purchaseScope.querySelector('.product-form__buttons');
    bindLensParameterFormData(root, productForm);
    const estimate = info?.querySelector('[id^="supply-estimate-"]');
    const intentSelector = root.querySelector('[data-city-lens-intent]');
    const planoInformation = root.querySelector('[data-city-plano-information]');
    const planoReceiptNotice = root.querySelector('[data-city-plano-receipt]');
    const otherPoweredCopy = planoInformation?.querySelector('[data-city-plano-other-colours]');
    const intentError = root.querySelector('[data-city-lens-intent-error]');
    const intentContinue = root.querySelector('[data-city-lens-intent-continue]');
    const intentInputs = Array.from(root.querySelectorAll('[data-city-lens-intent-option]'));
    const productPlanoAvailable = root.dataset.cityPlanoAvailable === 'true';
    const productPrescriptionAvailable = root.dataset.cityPrescriptionAvailable === 'true';
    const hasDualIntent = Boolean(intentSelector);
    const prescriptionHeading = root.querySelector('[data-city-colour-prescription-heading]');
    const prescriptionRoutes = root.querySelector('[data-city-colour-prescription-routes]');
    const converterHelper = root.querySelector('.clc-pdp-helper');
    const uploadSlot = root.querySelector('[data-city-rx-app-upload-slot]');
    const manualReturn = root.querySelector('.city-rx-manual-return');
    const samePrescriptionInput = root.querySelector('#same');
    const samePrescription = samePrescriptionInput?.closest('.product-form__input');
    const quantityField = Array.from(root.querySelectorAll('.product-form__input')).find((field) => /^quantity$/i.test(field.querySelector(':scope > .form__label')?.textContent?.trim() || ''));
    const manualFields = Array.from(root.querySelectorAll('[data-city-rx-manual-fields]'));
    const fieldLabel = (field) => field.querySelector(':scope > .form__label')?.textContent?.trim() || '';
    const fixedDimensionFields = manualFields.filter((field) => {
      const label = fieldLabel(field);
      if (!/^(base curve|diameter)$/i.test(label)) return false;
      const values = [...field.querySelectorAll('select')].map((select) => select.value).filter(Boolean);
      const locked = [...field.querySelectorAll('.city-rx-locked-value')].map((node) => node.textContent.trim()).filter(Boolean);
      return new Set([...values, ...locked]).size <= 1;
    });
    const prescriptionFields = manualFields.filter((field) => !fixedDimensionFields.includes(field) && !/^colou?r$/i.test(fieldLabel(field)));
    const manualGroup = quantityField?.parentElement || prescriptionFields[0]?.parentElement;

    product.dataset.cityColourPackMode = isFixedPack ? 'fixed' : isMultiPack ? 'multi' : 'unknown';
    root.dataset.cityColourPackMode = product.dataset.cityColourPackMode;

    if (colourField) {
      let flowAnchor = colourField;
      if (isMultiPack && variantPicker) {
        variantPicker.classList.add('city-colour-pack-selector');
        const packLegend = packOptionField?.querySelector('legend, .form__label');
        if (packLegend && /^size$/i.test(packLegend.textContent.trim())) packLegend.textContent = 'Choose your pack size';
        flowAnchor.insertAdjacentElement('afterend', variantPicker);
        flowAnchor = variantPicker;
      } else if (isFixedPack && variantPicker) {
        variantPicker.classList.add('city-colour-original-pack--hidden');
      }

      [planoInformation, intentSelector, planoReceiptNotice, prescriptionHeading, prescriptionRoutes, converterHelper, uploadSlot, manualReturn, ...prescriptionFields, manualGroup].filter(Boolean).forEach((element) => {
        flowAnchor.insertAdjacentElement('afterend', element);
        flowAnchor = element;
      });
    }

    let packPriceNote = root.querySelector('[data-city-lens-pack-price-note]');
    if (isMultiPack && variantPicker && !packPriceNote) {
      packPriceNote = document.createElement('p');
      packPriceNote.className = 'city-lens-pack-price-note';
      packPriceNote.dataset.cityLensPackPriceNote = '';
      packPriceNote.innerHTML = '<strong>Prices shown per box.</strong> <span data-city-powered-box-note>Different eye powers require separate boxes.</span>';
      variantPicker.insertAdjacentElement('afterend', packPriceNote);
    }

    fixedDimensionFields.forEach((field) => {
      field.classList.add('city-colour-fixed-dimension-field');
      field.setAttribute('aria-hidden', 'true');
    });
    prescriptionFields.forEach((field) => field.classList.add('city-colour-prescription-field'));
    quantityField?.classList.add('city-colour-quantity-field');

    samePrescription?.classList.add('city-colour-same-prescription-field');
    const sphereField = prescriptionFields.find((field) => /^sphere power$/i.test(fieldLabel(field)));
    const sphereLabel = sphereField?.querySelector(':scope > .form__label');
    if (samePrescription && sphereLabel) sphereLabel.insertAdjacentElement('afterend', samePrescription);
    else if (samePrescription && sphereField) sphereField.insertAdjacentElement('beforebegin', samePrescription);

    const colourMap = readMap(root);

    const optionLabelRaw = packOptionField?.querySelector('label')?.innerText?.trim().replace(/\s+/g, ' ') || optionInputs[0]?.value || '';
    const priceMatches = Array.from(optionLabelRaw.matchAll(/\$([\d,.]+)/g));
    const packPrice = priceMatches.length ? Number(priceMatches[0][1].replace(/,/g, '')) : 0;
    const lensCountMatch = optionLabelRaw.match(/(\d+)\s+lenses?/i);
    const lensesPerBox = lensCountMatch ? Number(lensCountMatch[1]) : 0;
    const leftQuantity = info?.querySelector('select[name="properties[Quantity Left]"]');
    const rightQuantity = info?.querySelector('select[name="properties[Quantity Right]"]');
    const quantityGrid = quantityField?.querySelector(':scope > div');
    const leftQuantityShell = leftQuantity?.closest('div[style*="position: relative"]') || leftQuantity?.parentElement;
    const rightQuantityShell = rightQuantity?.closest('div[style*="position: relative"]') || rightQuantity?.parentElement;
    const leftQuantityEyeLabel = leftQuantity?.parentElement?.querySelector(':scope > div');
    const fixedPairBoxProduct = isFixedPack && lensesPerBox === 2;
    let savedRightQuantity = Math.max(1, Number(rightQuantity?.value || 1));
    let syncingQuantityMode = false;
    let lensIntent = hasDualIntent ? '' : productPlanoAvailable && !productPrescriptionAvailable ? 'plano' : 'powered';
    let savedPoweredState = null;
    let previousAvailabilityKind = '';

    const currentShadeName = () => root.querySelector('input[name="properties[Colour]"]')?.value
      || root.querySelector('input[name="properties[Colour Left]"]')?.value
      || root.querySelector('.city-colour-picker__option.is-selected')?.dataset.colourName
      || '';
    const selectedPackName = () => optionInputs.find((input) => input.checked)?.value || optionInputs[0]?.value || '';
    const intentDefaults = { plano: productPlanoAvailable, powered: productPrescriptionAvailable };
    const currentIntentAvailability = () => shadeIntentAvailability(colourMap, currentShadeName(), intentDefaults);
    const historyIntentState = () => {
      const state = window.history?.state?.cityLensIntent;
      if (!state || String(state.productId) !== String(root.dataset.productId || '')) return '';
      if (state.shade !== currentShadeName() || state.pack !== selectedPackName()) return '';
      return state.value === 'plano' || state.value === 'powered' ? state.value : '';
    };
    const persistIntentState = () => {
      if (!window.history?.replaceState) return;
      window.history.replaceState({
        ...(window.history.state || {}),
        cityLensIntent: {
          productId: root.dataset.productId || '',
          shade: currentShadeName(),
          pack: selectedPackName(),
          value: lensIntent
        }
      }, '', window.location.href);
    };
    const setFlowHidden = (node, hidden) => {
      if (!node) return;
      node.classList.toggle('city-lens-intent-flow-hidden', hidden);
      node.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    };
    const poweredFlowNodes = [prescriptionHeading, prescriptionRoutes, converterHelper, uploadSlot, manualReturn, samePrescription, ...prescriptionFields];
    const poweredControls = prescriptionFields.flatMap((field) => Array.from(field.querySelectorAll('input, select, textarea')));
    const planoPowerInputs = ['Left', 'Right'].map((side) => {
      if (!productForm) return null;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[Sphere Power ${side}]`;
      input.value = '+0.00';
      input.dataset.cityPlanoPower = side.toLowerCase();
      input.disabled = true;
      productForm.appendChild(input);
      return input;
    }).filter(Boolean);
    let intentProperty = productForm?.querySelector('input[data-city-lens-intent-property], input[name="properties[Lens Intent]"]');
    const existingIntentValue = String(intentProperty?.value || '').toLowerCase();
    const existingIntent = existingIntentValue.includes('plano')
      ? 'plano'
      : existingIntentValue.includes('vision correction') || existingIntentValue.includes('powered') ? 'powered' : '';
    if (!intentProperty && productForm) {
      intentProperty = document.createElement('input');
      intentProperty.type = 'hidden';
      intentProperty.name = 'properties[Lens Intent]';
      intentProperty.dataset.cityLensIntentProperty = '';
      intentProperty.disabled = true;
      productForm.appendChild(intentProperty);
    } else if (intentProperty) {
      intentProperty.dataset.cityLensIntentProperty = '';
    }
    const zeroPowerValue = () => {
      const values = Array.from(root.querySelectorAll('[data-city-rx-manual-fields] select'))
        .flatMap((select) => Array.from(select.options).map((option) => option.value));
      return values.find((value) => Number.parseFloat(String(value).replace('+', '')) === 0) || '+0.00';
    };
    const clearUploadState = () => {
      productForm?.querySelectorAll('input[name*="Prescription Upload"], textarea[name*="Prescription Upload"]').forEach((field) => {
        field.value = '';
        field.disabled = true;
      });
      uploadSlot?.querySelectorAll('input[type="file"]').forEach((field) => {
        field.value = '';
        field.disabled = true;
      });
    };
    const setPoweredControlsDisabled = (disabled) => {
      poweredControls.forEach((control) => {
        if (disabled) {
          if (control.name && !control.dataset.cityPoweredName) control.dataset.cityPoweredName = control.name;
          control.removeAttribute('name');
          control.disabled = true;
          control.required = false;
        } else {
          if (control.dataset.cityPoweredName) control.name = control.dataset.cityPoweredName;
          control.disabled = false;
          if (control.tagName === 'SELECT' && !/^(base curve|diameter)$/i.test(fieldLabel(control.closest('[data-city-rx-manual-fields]')))) control.required = true;
        }
      });
    };
    const showIntentError = () => {
      if (!intentSelector || !intentError) return;
      intentSelector.classList.add('is-invalid');
      intentError.hidden = false;
    };
    const clearIntentError = () => {
      intentSelector?.classList.remove('is-invalid');
      if (intentError) intentError.hidden = true;
    };
    const announceIntent = (value) => {
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: 'lens_intent_selected',
        lens_intent: value,
        product_id: root.dataset.productId || '',
        product_handle: root.dataset.productHandle || '',
        shade: currentShadeName(),
        pack_size: selectedPackName()
      });
    };

    let samePrescriptionProperty = productForm?.querySelector('input[name="properties[Same Prescription]"]');
    if (!samePrescriptionProperty && productForm && (fixedPairBoxProduct || isMultiPack)) {
      samePrescriptionProperty = document.createElement('input');
      samePrescriptionProperty.type = 'hidden';
      samePrescriptionProperty.name = 'properties[Same Prescription]';
      samePrescriptionProperty.disabled = true;
      productForm.appendChild(samePrescriptionProperty);
    }

    let cartQuantityInput = productForm?.querySelector(':scope > input[data-city-colour-cart-quantity]');
    if (!cartQuantityInput && productForm && (fixedPairBoxProduct || hasDualIntent)) {
      cartQuantityInput = document.createElement('input');
      cartQuantityInput.type = 'hidden';
      cartQuantityInput.name = 'quantity';
      cartQuantityInput.dataset.cityColourCartQuantity = '';
      cartQuantityInput.value = '1';
      productForm.appendChild(cartQuantityInput);
    }
    const setCartQuantity = (boxes) => {
      const value = String(Math.max(0, Number(boxes || 0)));
      if (productForm) productForm.dataset.cityColourTotalBoxes = value;
      if (cartQuantityInput) {
        cartQuantityInput.value = value;
        cartQuantityInput.setAttribute('value', value);
      }
    };

    const matchingEyeConfiguration = () => {
      const controls = Array.from(root.querySelectorAll('[name^="properties["]'));
      const valuesByName = new Map(controls.map((control) => [control.name, String(control.value || '').trim()]));
      return controls
        .filter((control) => / Left\]$/.test(control.name) && !/Quantity Left\]$/.test(control.name))
        .every((leftControl) => {
          const rightName = leftControl.name.replace(/ Left\]$/, ' Right]');
          return !valuesByName.has(rightName) || valuesByName.get(rightName) === String(leftControl.value || '').trim();
        });
    };

    const usesSharedBoxes = () => (fixedPairBoxProduct || isMultiPack)
      && Boolean(samePrescriptionInput?.checked)
      && matchingEyeConfiguration();

    const setSelectValue = (select, value) => {
      if (!select || String(select.value) === String(value)) return;
      select.value = String(value);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const syncSharedQuantityLabel = (shared) => {
      if (!leftQuantityEyeLabel) return;
      if (!shared) {
        leftQuantityEyeLabel.textContent = 'Left Eye';
        return;
      }
      leftQuantityEyeLabel.textContent = Number(leftQuantity?.value || 0) === 1 ? 'box' : 'boxes';
    };

    const applyLensIntent = (value, { announce = false, persist = true } = {}) => {
      const availability = currentIntentAvailability();
      const nextValue = value && availability[value] ? value : '';
      if (nextValue === 'plano' && lensIntent !== 'plano') {
        savedPoweredState = {
          controls: poweredControls.map((control) => ({ control, value: control.value })),
          rightQuantity: Math.max(1, Number(rightQuantity?.value || savedRightQuantity || 1)),
          same: Boolean(samePrescriptionInput?.checked)
        };
      }
      lensIntent = nextValue;
      root.dataset.cityLensIntent = lensIntent;
      root.dataset.cityHealthFundMode = lensIntent === 'plano' ? 'receipt' : lensIntent === 'powered' ? 'powered' : 'pending';
      if (productForm) productForm.dataset.cityLensIntent = lensIntent;
      intentInputs.forEach((input) => {
        input.checked = input.value === lensIntent;
        input.closest('.city-lens-intent__option')?.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      });
      clearIntentError();

      const neutral = !lensIntent;
      const plano = lensIntent === 'plano';
      poweredFlowNodes.forEach((node) => setFlowHidden(node, neutral || plano));
      setFlowHidden(intentContinue, !neutral);
      setFlowHidden(quantityField, neutral);
      quantityField?.classList.toggle('is-plano-quantity', plano);
      if (rightQuantityShell) {
        rightQuantityShell.dataset.cityPlanoHiddenEye = plano ? 'true' : 'false';
        rightQuantityShell.hidden = plano;
      }
      syncSharedQuantityLabel(plano);
      if (packPriceNote) {
        const poweredNote = packPriceNote.querySelector('[data-city-powered-box-note]');
        if (poweredNote) poweredNote.hidden = plano;
      }

      if (plano) {
        if (samePrescriptionInput) samePrescriptionInput.checked = false;
        savedRightQuantity = Math.max(1, Number(savedPoweredState?.rightQuantity || savedRightQuantity || 1));
        setSelectValue(rightQuantity, 0);
        const planoValue = zeroPowerValue();
        planoPowerInputs.forEach((input) => {
          input.value = planoValue;
          input.disabled = false;
        });
        if (intentProperty) {
          intentProperty.value = 'Colour only (Plano)';
          intentProperty.disabled = false;
        }
        clearUploadState();
        setPoweredControlsDisabled(true);
      } else {
        planoPowerInputs.forEach((input) => { input.disabled = true; });
        if (lensIntent === 'powered') {
          productForm?.querySelectorAll('input[name*="Prescription Upload"], textarea[name*="Prescription Upload"]').forEach((field) => { field.disabled = false; });
          uploadSlot?.querySelectorAll('input[type="file"]').forEach((field) => { field.disabled = false; });
        }
        if (intentProperty) {
          intentProperty.value = lensIntent === 'powered' ? 'With vision correction' : '';
          intentProperty.disabled = !lensIntent;
        }
        setPoweredControlsDisabled(neutral);
        if (lensIntent === 'powered' && savedPoweredState) {
          savedPoweredState.controls.forEach(({ control, value: savedValue }) => {
            if (control.isConnected) control.value = savedValue;
          });
          if (samePrescriptionInput) samePrescriptionInput.checked = savedPoweredState.same;
          setSelectValue(rightQuantity, savedPoweredState.rightQuantity || 1);
        } else if (lensIntent === 'powered' && rightQuantity && Number(rightQuantity.value || 0) < 1) {
          setSelectValue(rightQuantity, savedRightQuantity || 1);
        }
      }

      if (persist) persistIntentState();
      if (announce && lensIntent) announceIntent(lensIntent);
      root.classList.add('city-lens-intent-ready');
    };

    const refreshIntentAvailability = () => {
      const availability = currentIntentAvailability();
      const presentation = shadePowerPresentation(colourMap, currentShadeName(), intentDefaults);
      if (planoInformation) planoInformation.hidden = !presentation.planoOnly;
      if (otherPoweredCopy) otherPoweredCopy.hidden = !presentation.otherPowered;
      intentInputs.forEach((input) => {
        const available = Boolean(availability[input.value]);
        input.disabled = !available;
        const option = input.closest('.city-lens-intent__option');
        if (option) {
          option.hidden = !available;
          option.title = available ? '' : `${input.value === 'plano' ? 'Plano' : 'Powered lenses'} unavailable for this shade`;
        }
      });
      const availableValues = Object.keys(availability).filter((key) => availability[key]);
      const availabilityKind = availableValues.join(',');
      if (intentSelector) intentSelector.hidden = availableValues.length < 2;
      if (availableValues.length === 1) applyLensIntent(availableValues[0], { announce: false, persist: true });
      else if (availableValues.length === 2 && previousAvailabilityKind && previousAvailabilityKind !== 'plano,powered') {
        savedPoweredState = null;
        applyLensIntent('', { announce: false, persist: true });
      }
      else if (lensIntent && !availability[lensIntent]) applyLensIntent('', { announce: false, persist: false });
      previousAvailabilityKind = availabilityKind;
    };

    const syncSamePrescriptionQuantityMode = () => {
      if (!(fixedPairBoxProduct || isMultiPack) || !leftQuantity || !rightQuantity || syncingQuantityMode) return usesSharedBoxes();
      syncingQuantityMode = true;
      const shared = usesSharedBoxes();
      if (shared) {
        if (!quantityField.classList.contains('is-same-prescription')) {
          savedRightQuantity = Math.max(1, Number(rightQuantity.value || 1));
        }
        quantityField.classList.add('is-same-prescription');
        syncSharedQuantityLabel(true);
        if (rightQuantityShell) rightQuantityShell.hidden = true;
        setSelectValue(rightQuantity, 0);
      } else {
        const wasShared = quantityField.classList.contains('is-same-prescription');
        quantityField.classList.remove('is-same-prescription');
        syncSharedQuantityLabel(false);
        if (rightQuantityShell) rightQuantityShell.hidden = false;
        if (wasShared && samePrescriptionInput && !samePrescriptionInput.checked) {
          setSelectValue(rightQuantity, savedRightQuantity || 1);
        }
      }
      syncingQuantityMode = false;
      return shared;
    };

    const updateParameters = () => readLensParameterLine(root);

    purchaseScope.querySelector('[data-city-colour-supply-summary]')?.remove();
    if ((isFixedPack || isMultiPack) && estimate) {
      estimate.hidden = true;
      estimate.setAttribute('aria-hidden', 'true');
    }

    let summary = purchaseScope.querySelector('[data-city-colour-order-summary]');
    if ((isFixedPack || isMultiPack) && !summary && buttons && (leftQuantity || rightQuantity)) {
      summary = document.createElement('div');
      summary.className = `city-colour-order-summary${isMultiPack ? ' city-colour-order-summary--compact' : ''}`;
      summary.dataset.cityColourOrderSummary = '';
      summary.setAttribute('aria-live', 'polite');
      buttons.insertAdjacentElement('beforebegin', summary);
    }
    const placeOrderSummary = () => {
      if (!summary || !productForm || !buttons) return;
      const custom = productForm?.querySelector('[data-city-contact-purchase-options]:not([hidden])');
      if (custom) {
        if (summary.previousElementSibling !== custom) custom.insertAdjacentElement('afterend', summary);
        return;
      }
      const purchaseOptions = productForm.querySelector('.appstle_sub_widget');
      if (purchaseOptions) {
        if (summary.nextElementSibling !== purchaseOptions) purchaseOptions.insertAdjacentElement('beforebegin', summary);
      } else if (summary.nextElementSibling !== buttons) {
        buttons.insertAdjacentElement('beforebegin', summary);
      }
    };
    const syncIntentDisclosure = () => {
      if (!hasDualIntent) return;
      const neutral = !lensIntent;
      const purchaseOptions = productForm?.querySelector('.appstle_sub_widget');
      setFlowHidden(summary, neutral);
      setFlowHidden(purchaseOptions, neutral);
      setFlowHidden(buttons, neutral);
      setFlowHidden(quantityField, neutral);
    };
    placeOrderSummary();

    purchaseScope.querySelector('[data-city-colour-purchase-trust]')?.remove();

    const submitButton = productForm?.querySelector('[type="submit"]');
    const submitLabel = submitButton?.querySelector('span');
    const currentSubmitButton = () => productForm?.querySelector('[type="submit"]') || submitButton;
    const currentSubmitLabel = () => currentSubmitButton()?.querySelector('span') || submitLabel;
    const getFirstIncompleteManualPrescriptionField = () => Array.from(
      root.querySelectorAll('[data-city-rx-manual-fields] select[required]:not(:disabled)')
    ).find((field) => !String(field.value || '').trim() || (field.validity && !field.validity.valid)) || null;
    const hasCompletedPrescriptionUpload = () => {
      if (!uploadSlot) return false;
      if (uploadSlot.querySelector('[data-filepond-item-state="processing-complete"]')) return true;
      return Array.from(productForm?.querySelectorAll(
        'input[name*="Prescription Upload"], textarea[name*="Prescription Upload"]'
      ) || []).some((field) => /cloudlift\.app/i.test(String(field.value || '')));
    };
    const getPrescriptionValidationState = () => {
      if (!(isFixedPack || isMultiPack)) return { complete: true, mode: 'none', target: null };
      if (hasDualIntent && !lensIntent) return { complete: false, mode: 'intent', target: intentSelector };
      if (lensIntent === 'plano') return { complete: true, mode: 'plano', target: null };
      const uploadMode = Boolean(uploadSlot?.classList.contains('is-open'));
      if (uploadMode) {
        return {
          complete: hasCompletedPrescriptionUpload(),
          mode: 'upload',
          target: uploadSlot?.querySelector('.filepond--drop-label label')
            || uploadSlot?.querySelector('input[type="file"]:not(:disabled)')
            || uploadSlot
        };
      }
      const target = getFirstIncompleteManualPrescriptionField();
      return { complete: !target, mode: 'manual', target };
    };
    const focusFirstIncompletePrescriptionField = () => {
      const state = getPrescriptionValidationState();
      if (state.complete || !state.target) return false;
      if (state.mode === 'intent') showIntentError();
      state.target.setAttribute('aria-invalid', 'true');
      if (!state.target.matches('input, select, textarea, button, a[href], [tabindex]')) {
        state.target.setAttribute('tabindex', '-1');
      }
      if (typeof state.target.focus === 'function') state.target.focus({ preventScroll: true });
      state.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    };
    const updatePrescriptionCtaState = (currentTotal = null) => {
      const activeSubmitButton = currentSubmitButton();
      const activeSubmitLabel = currentSubmitLabel();
      if (!(isFixedPack || isMultiPack) || !productForm || !activeSubmitButton || !activeSubmitLabel) return;
      const prescriptionState = getPrescriptionValidationState();
      const stickySubmit = document.querySelector('[data-city-sticky-submit]');
      const desiredCtaText = () => {
        const complete = productForm.dataset.cityColourPrescriptionComplete === 'true';
        const hasBoxes = Number(productForm.dataset.cityColourTotalBoxes || 0) > 0;
        const storedTotal = Number(productForm.dataset.cityColourCurrentTotal || 0);
        if (complete && hasBoxes && productForm.dataset.cityPurchaseOptionsReady === 'true' && productForm.dataset.cityClearStickyText) {
          return productForm.dataset.cityClearStickyText;
        }
        if (complete && hasBoxes && storedTotal > 0) return `Add to cart — $${storedTotal.toFixed(2)}`;
        return productForm.dataset.cityColourPrescriptionMode === 'intent' ? 'Choose a lens type to continue' : 'Complete prescription';
      };
      const syncMainCtaState = () => {
        const button = currentSubmitButton();
        const label = currentSubmitLabel();
        if (!button || !label) return;
        const complete = productForm.dataset.cityColourPrescriptionComplete === 'true';
        const hasBoxes = Number(productForm.dataset.cityColourTotalBoxes || 0) > 0;
        const desiredText = desiredCtaText();
        if (label.textContent.trim() !== desiredText) label.textContent = desiredText;
        button.setAttribute('aria-disabled', complete && hasBoxes ? 'false' : 'true');
      };
      const syncStickyCtaState = () => {
        if (!stickySubmit) return;
        const complete = productForm.dataset.cityColourPrescriptionComplete === 'true';
        const hasBoxes = Number(productForm.dataset.cityColourTotalBoxes || 0) > 0;
        const desiredText = desiredCtaText();
        const desiredMode = complete && hasBoxes ? 'complete' : 'incomplete';
        if (stickySubmit.textContent.trim() !== desiredText) stickySubmit.textContent = desiredText;
        if (stickySubmit.dataset.cityStickyRxMode !== desiredMode) stickySubmit.dataset.cityStickyRxMode = desiredMode;
        stickySubmit.classList.toggle('is-secondary', desiredMode === 'incomplete');
        stickySubmit.setAttribute('aria-disabled', desiredMode === 'incomplete' ? 'true' : 'false');
        setFlowHidden(stickySubmit, productForm.dataset.cityColourPrescriptionMode === 'intent');
      };
      productForm.dataset.cityColourPrescriptionComplete = prescriptionState.complete ? 'true' : 'false';
      productForm.dataset.cityColourPrescriptionMode = prescriptionState.mode;
      if (prescriptionState.complete) {
        productForm.querySelectorAll('[data-city-rx-validation-message]').forEach((message) => message.remove());
        root.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
      }
      if (stickySubmit && stickySubmit.dataset.cityColourCtaObserverReady !== 'true') {
        stickySubmit.dataset.cityColourCtaObserverReady = 'true';
        new MutationObserver(() => window.queueMicrotask(syncStickyCtaState)).observe(stickySubmit, {
          attributes: true,
          attributeFilter: ['class', 'data-city-sticky-rx-mode'],
          childList: true,
          characterData: true,
          subtree: true
        });
      }
      if (productForm.dataset.cityColourMainCtaObserverReady !== 'true') {
        productForm.dataset.cityColourMainCtaObserverReady = 'true';
        new MutationObserver(() => window.queueMicrotask(syncMainCtaState)).observe(productForm, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
      if (!prescriptionState.complete) {
        activeSubmitLabel.textContent = prescriptionState.mode === 'intent' ? 'Choose a lens type to continue' : 'Complete prescription';
        activeSubmitButton.dataset.cityDisabledByPrescription = 'true';
        activeSubmitButton.setAttribute('aria-disabled', 'true');
        if (stickySubmit) {
          stickySubmit.textContent = prescriptionState.mode === 'intent' ? 'Choose a lens type to continue' : 'Complete prescription';
          stickySubmit.dataset.cityStickyRxMode = 'incomplete';
          stickySubmit.classList.add('is-secondary');
        }
      } else if (activeSubmitButton.dataset.cityDisabledByPrescription === 'true') {
        delete activeSubmitButton.dataset.cityDisabledByPrescription;
        if (activeSubmitButton.dataset.cityDisabledByEyeQuantity !== 'true') activeSubmitButton.removeAttribute('aria-disabled');
      }
      if (prescriptionState.complete && Number(productForm.dataset.cityColourTotalBoxes || 0) > 0 && stickySubmit) {
        if (Number.isFinite(currentTotal)) productForm.dataset.cityColourCurrentTotal = Number(currentTotal).toFixed(2);
      }
      syncMainCtaState();
      syncStickyCtaState();
    };
    let packVariants = [];
    try {
      packVariants = JSON.parse(variantPicker?.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (error) {
      packVariants = [];
    }
    const formatMoney = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)} AUD`;
    const setText = (node, value) => {
      if (node && node.textContent.trim() !== value) node.textContent = value;
    };
    const renderSummary = (html) => {
      if (summary && summary.innerHTML !== html) summary.innerHTML = html;
    };
    const parseMoneyCents = (value) => {
      const numeric = Number(String(value || '').replace(/[^\d.-]/g, ''));
      return Number.isFinite(numeric) && numeric > 0 ? Math.round(numeric * 100) : 0;
    };
    const appstleOptionUnitPriceCents = (option) => {
      const money = option?.querySelector('.appstle_subscription_amount .money');
      if (!money) return 0;
      const rawCents = parseMoneyCents(money.textContent);
      const renderedTotalCents = Number(money.dataset.citySummaryRenderedTotalCents || 0);
      const cachedUnitCents = Number(money.dataset.citySummaryUnitPriceCents || 0);
      if (cachedUnitCents > 0 && renderedTotalCents > 0 && rawCents === renderedTotalCents) return cachedUnitCents;
      if (rawCents > 0) money.dataset.citySummaryUnitPriceCents = String(rawCents);
      delete money.dataset.citySummaryRenderedTotalCents;
      return rawCents;
    };
    const selectedAppstleUnitPriceCents = () => {
      const selectedPlan = productForm?.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
      return appstleOptionUnitPriceCents(selectedPlan?.closest('.appstle_subscription_wrapper_option'));
    };
    const oneTimeAppstlePriceCents = () => {
      const oneTimePlan = productForm?.querySelector('.appstle_sub_widget input[name="selling_plan"][value=""]');
      return appstleOptionUnitPriceCents(oneTimePlan?.closest('.appstle_subscription_wrapper_option'));
    };
    const syncAppstleDisplayedTotals = (totalBoxes, checkoutUnitPriceCents) => {
      if (!productForm || totalBoxes < 1 || checkoutUnitPriceCents < 1) return;
      productForm.querySelectorAll('.appstle_subscription_wrapper_option').forEach((option) => {
        const renderedTotalCents = checkoutUnitPriceCents * totalBoxes;
        option
          .querySelectorAll(
            '.appstle_subscription_amount .money, .appstle_subscription_amount-appstle-sr-only .money',
          )
          .forEach((money) => {
          money.dataset.citySummaryUnitPriceCents = String(checkoutUnitPriceCents);
          money.dataset.citySummaryRenderedTotalCents = String(renderedTotalCents);
          setText(money, `$${(renderedTotalCents / 100).toFixed(2)}`);
          });
      });
    };
    const selectedPackDetails = (variant) => {
      const input = optionInputs.find((candidate) => candidate.checked);
      const label = input?.id ? packOptionField?.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      const source = `${input?.value || ''} ${label?.innerText || ''}`.replace(/\s+/g, ' ').trim();
      const countMatch = source.match(/(\d+)\s*(?:lenses?|pack|pk)\b/i) || source.match(/\b(\d+)\b/);
      return {
        input,
        source,
        lensesPerBox: countMatch ? Number(countMatch[1]) : 0,
        unitPriceCents: selectedAppstleUnitPriceCents() || Number(variant?.price || 0)
      };
    };
    const monthsLabel = (months) => {
      const rounded = Math.round(Number(months || 0) * 10) / 10;
      if (!rounded) return '';
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    };
    const monthDuration = (months) => {
      const label = monthsLabel(months);
      return label ? `${label} ${Number(label) === 1 ? 'month' : 'months'}` : '';
    };
    const supplyMonthsPerBox = () => {
      const match = String(estimate?.textContent || '').match(/~\s*([\d.]+)\s*months?\s+per eye/i);
      return match ? Number(match[1]) : 0;
    };
    const replacementMonthsPerLens = () => {
      const schedule = String(root.dataset.cityWearSchedule || '').toLowerCase();
      const explicitMonths = schedule.match(/([\d.]+)\s*months?/);
      if (explicitMonths) return Number(explicitMonths[1]);
      if (/six[-\s]?month/.test(schedule)) return 6;
      if (/fortnight|2[-\s]?week/.test(schedule)) return 0.5;
      if (/week/.test(schedule)) return 0.25;
      if (/daily|1[-\s]?day/.test(schedule)) return 1 / 30;
      if (/month/.test(schedule)) return 1;
      return 0;
    };
    const updateMultiPackPrice = () => {
      if (!isMultiPack) return null;
      const selectedPack = optionInputs.find((input) => input.checked)?.value;
      const variant = packVariants.find((candidate) => candidate.title === selectedPack || candidate.options?.includes(selectedPack));
      if (!variant) return null;
      const priceRoot = info?.querySelector('[id^="price-"]');
      updateCityRrpPrice(priceRoot?.querySelector('.city-rrp-price'), { price: variant.price, compareAtPrice: variant.compare_at_price, available: variant.available });
      return variant;
    };
    const updateSummary = () => {
      updateParameters();
      const selectedVariant = updateMultiPackPrice();
      if (!summary) return;
      placeOrderSummary();
      syncIntentDisclosure();
      if (hasDualIntent && !lensIntent) {
        setCartQuantity(0);
        updatePrescriptionCtaState(0);
        emitPurchaseSupply(productForm, false);
        return;
      }
      const plano = lensIntent === 'plano';
      const sharedBoxes = plano || syncSamePrescriptionQuantityMode();
      const leftBoxes = Number(leftQuantity?.value || 0);
      const rightBoxes = plano ? 0 : Number(rightQuantity?.value || 0);
      const totalBoxes = sharedBoxes ? leftBoxes : leftBoxes + rightBoxes;
      syncSharedQuantityLabel(sharedBoxes);
      const multiPack = selectedPackDetails(selectedVariant);
      const activeLensesPerBox = isMultiPack ? multiPack.lensesPerBox : lensesPerBox;
      const fixedBaseUnitPriceCents = Math.round(packPrice * 100);
      const activeUnitPriceCents = isMultiPack
        ? Number(selectedVariant?.price || multiPack.unitPriceCents || 0)
        : fixedBaseUnitPriceCents;
      const totalLenses = activeLensesPerBox > 0 ? totalBoxes * activeLensesPerBox : 0;
      const total = totalBoxes * activeUnitPriceCents / 100;
      if (productForm) productForm.dataset.cityColourCurrentTotal = total.toFixed(2);
      const boxLabel = `${totalBoxes} ${totalBoxes === 1 ? 'box' : 'boxes'}`;
      const lensLabel = totalLenses ? ` · ${totalLenses} lenses total` : '';
      const replacementLine = plano
        ? (() => {
            const replacementMonths = replacementMonthsPerLens();
            const bothEyesMonths = replacementMonths && totalLenses ? totalLenses * replacementMonths / 2 : 0;
            return bothEyesMonths ? `Approx. ${monthDuration(bothEyesMonths)} for both eyes` : '';
          })()
        : isFixedPack
        ? (() => {
            if (sharedBoxes) return `Approx. ${totalBoxes * 6} months supply for both eyes · Six-month replacement`;
            if (leftBoxes > 0 && rightBoxes > 0 && leftBoxes === rightBoxes) return `Approx. ${leftBoxes * 12} months per eye · Six-month replacement`;
            const eyes = [];
            if (leftBoxes > 0) eyes.push(`Left eye ~${leftBoxes * 12} months`);
            if (rightBoxes > 0) eyes.push(`Right eye ~${rightBoxes * 12} months`);
            return eyes.length ? `Approx. supply: ${eyes.join(' · ')} · Six-month replacement` : '';
          })()
        : (() => {
            if (sharedBoxes) {
              const replacementMonths = replacementMonthsPerLens();
              const bothEyesMonths = replacementMonths && totalLenses ? totalLenses * replacementMonths / 2 : 0;
              return bothEyesMonths ? `Approx. ${monthDuration(bothEyesMonths)} for both eyes` : '';
            }
            const perBoxMonths = supplyMonthsPerBox();
            if (!perBoxMonths) return '';
            if (leftBoxes > 0 && rightBoxes > 0 && leftBoxes === rightBoxes) {
              return `Approx. ${monthDuration(leftBoxes * perBoxMonths)} per eye`;
            }
            const eyes = [];
            if (leftBoxes > 0) eyes.push(`Left eye ~${monthDuration(leftBoxes * perBoxMonths)}`);
            if (rightBoxes > 0) eyes.push(`Right eye ~${monthDuration(rightBoxes * perBoxMonths)}`);
            return eyes.length ? `Approx. supply: ${eyes.join(' · ')}` : '';
          })();
      const perLens = isFixedPack && activeLensesPerBox > 0 && activeUnitPriceCents > 0
        ? `$${(activeUnitPriceCents / 100 / activeLensesPerBox).toFixed(2)} per lens`
        : '';
      const parameterLine = parameterSummaryHtml(root);
      renderSummary(totalBoxes > 0
        ? `<span>Order summary</span><strong>${boxLabel}${lensLabel} · $${total.toFixed(2)}</strong>${replacementLine ? `<small>${replacementLine}</small>` : ''}${perLens ? `<small>${perLens}</small>` : ''}${parameterLine}`
        : `<span>Order summary</span><strong>Choose at least one box</strong>${parameterLine}`);
      syncAppstleDisplayedTotals(totalBoxes, activeUnitPriceCents);

      if (samePrescriptionProperty) {
        samePrescriptionProperty.disabled = !sharedBoxes || plano;
        samePrescriptionProperty.value = sharedBoxes && !plano ? 'Yes — both eyes share one prescription' : '';
        samePrescriptionProperty.dataset.cityColourSamePrescriptionValue = samePrescriptionProperty.value;
      }
      setCartQuantity(totalBoxes);

      const activeSubmitButton = currentSubmitButton();
      const activeSubmitLabel = currentSubmitLabel();
      if (activeSubmitLabel && activeSubmitButton?.dataset.cityDisabledByPrescription !== 'true') {
        setText(activeSubmitLabel, totalBoxes > 0 ? `Add to cart — $${total.toFixed(2)}` : 'Add to cart');
      }
      if (activeSubmitButton) {
        if (totalBoxes < 1) {
          activeSubmitButton.dataset.cityDisabledByEyeQuantity = 'true';
          activeSubmitButton.disabled = true;
          activeSubmitButton.setAttribute('aria-disabled', 'true');
        } else if (activeSubmitButton.dataset.cityDisabledByEyeQuantity === 'true') {
          delete activeSubmitButton.dataset.cityDisabledByEyeQuantity;
          activeSubmitButton.disabled = false;
          activeSubmitButton.removeAttribute('aria-disabled');
        }
      }
      updatePrescriptionCtaState(total);
      emitPurchaseSupply(productForm, sharedBoxes);

    };

    if (root.dataset.cityColourFixedPackLogicReady !== 'true') {
      root.dataset.cityColourFixedPackLogicReady = 'true';
      intentInputs.forEach((input) => input.addEventListener('change', () => {
        if (!input.checked) return;
        applyLensIntent(input.value, { announce: true, persist: true });
        [0, 80, 350].forEach((delay) => window.setTimeout(updateSummary, delay));
      }));
      [leftQuantity, rightQuantity].filter(Boolean).forEach((select) => select.addEventListener('change', updateSummary));
      samePrescriptionInput?.addEventListener('change', () => {
        [0, 60, 600].forEach((delay) => window.setTimeout(updateSummary, delay));
      });
      root.addEventListener('change', (event) => {
        if (!event.target.matches('select[name^="properties["]') || /Quantity (Left|Right)\]$/.test(event.target.name)) return;
        if (event.target.value) event.target.removeAttribute('aria-invalid');
        [0, 120, 600].forEach((delay) => window.setTimeout(updateSummary, delay));
      });
      root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-city-colour-prescription-routes], .city-rx-manual-return')) return;
        [0, 60, 400].forEach((delay) => window.setTimeout(updateSummary, delay));
      });
      submitButton?.addEventListener('click', (event) => {
        if (getPrescriptionValidationState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusFirstIncompletePrescriptionField();
      }, true);
      productForm?.addEventListener('click', (event) => {
        if (!event.target.closest('[type="submit"]') || getPrescriptionValidationState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusFirstIncompletePrescriptionField();
      }, true);
      productForm?.addEventListener('submit', (event) => {
        if (getPrescriptionValidationState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusFirstIncompletePrescriptionField();
      }, true);
      document.querySelector('[data-city-sticky-submit]')?.addEventListener('click', (event) => {
        if (getPrescriptionValidationState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusFirstIncompletePrescriptionField();
      }, true);
      productForm?.addEventListener('formdata', (event) => {
        if (!lensIntent) {
          event.formData.delete('properties[Lens Intent]');
          return;
        }
        event.formData.set('properties[Lens Intent]', lensIntent === 'plano' ? 'Colour only (Plano)' : 'With vision correction');
        if (lensIntent !== 'plano') {
          if (!usesSharedBoxes()) {
            event.formData.delete('properties[Same Prescription]');
            return;
          }
          event.formData.set('properties[Side]', 'Both Eyes');
          event.formData.set('quantity', productForm.dataset.cityColourTotalBoxes || String(leftQuantity?.value || 1));
          event.formData.set('properties[Same Prescription]', samePrescriptionProperty?.dataset.cityColourSamePrescriptionValue || 'Yes — both eyes share one prescription');
          // Match the fetch path: one shared Rx, with no per-eye quantities to split downstream.
          Array.from(event.formData.keys()).forEach((key) => {
            const eyeProperty = key.match(/^properties\[(.+) (Left|Right)\]$/);
            if (!eyeProperty) return;
            if (eyeProperty[2] === 'Left' && eyeProperty[1] !== 'Quantity') {
              event.formData.set(`properties[${eyeProperty[1]}]`, event.formData.get(key));
            }
            event.formData.delete(key);
          });
          return;
        }
        const planoValue = zeroPowerValue();
        event.formData.set('properties[Side]', 'Both Eyes');
        event.formData.set('quantity', productForm.dataset.cityColourTotalBoxes || String(leftQuantity?.value || 1));
        event.formData.set('properties[Sphere Power Left]', planoValue);
        event.formData.set('properties[Sphere Power Right]', planoValue);
        event.formData.delete('properties[Quantity Left]');
        event.formData.delete('properties[Quantity Right]');
        event.formData.delete('properties[Same Prescription]');
        Array.from(event.formData.keys()).forEach((key) => {
          if (/^properties\[(?:Cylinder Power|Axis|Add) (?:Left|Right)\]$/.test(key) || /Prescription Upload/i.test(key)) {
            event.formData.delete(key);
          }
        });
      });
      if (uploadSlot) {
        uploadSlot.addEventListener('change', () => window.setTimeout(updateSummary, 0), true);
        new MutationObserver(() => window.setTimeout(updateSummary, 0)).observe(uploadSlot, {
          attributes: true,
          attributeFilter: ['class', 'data-filepond-item-state', 'value'],
          childList: true,
          subtree: true
        });
      }
      if (fixedPairBoxProduct) {
        productForm?.addEventListener('submit', () => {
          setCartQuantity(productForm.dataset.cityColourTotalBoxes || 0);
          if (samePrescriptionProperty && samePrescriptionProperty.dataset.cityColourSamePrescriptionValue) {
            samePrescriptionProperty.value = samePrescriptionProperty.dataset.cityColourSamePrescriptionValue;
          }
        }, true);
        productForm?.addEventListener('formdata', (event) => {
          event.formData.set('quantity', productForm.dataset.cityColourTotalBoxes || '0');
        });
      }
    }
    optionInputs.forEach((input) => input.addEventListener('change', () => {
      if (lensIntent) persistIntentState();
      [0, 120, 600].forEach((delay) => window.setTimeout(updateSummary, delay));
    }));
    if (estimate && isMultiPack && estimate.dataset.cityColourSummaryObserver !== 'true') {
      estimate.dataset.cityColourSummaryObserver = 'true';
      new MutationObserver(() => window.queueMicrotask(updateSummary)).observe(estimate, { childList: true, subtree: true, characterData: true });
    }
    if (productForm && productForm.dataset.cityColourPurchaseOptionSummaryReady !== 'true') {
      productForm.dataset.cityColourPurchaseOptionSummaryReady = 'true';
      productForm.addEventListener('change', (event) => {
        if (event.target.matches('.appstle_sub_widget input[name="selling_plan"], .appstle_sub_widget select')) {
          [0, 120, 500].forEach((delay) => window.setTimeout(updateSummary, delay));
        }
      });
    }
    window.addEventListener('city:colour-preview', (event) => {
      if (String(event.detail?.productId || '') === String(root.dataset.productId || '')) {
        window.setTimeout(() => {
          refreshIntentAvailability();
          if (lensIntent) persistIntentState();
          updateSummary();
        }, 0);
      }
    });
    setupShadeSelector(root, colourMap);
    setupResponsivePdpOrder({ product, mediaWrapper, toolbox, gallery }, root, productForm);
    refreshIntentAvailability();
    if (hasDualIntent && !intentSelector.hidden) {
      const requestedIntent = new URLSearchParams(window.location.search).get('lens_intent');
      const restoredIntent = historyIntentState()
        || existingIntent
        || (requestedIntent === 'plano' || requestedIntent === 'powered' ? requestedIntent : '');
      applyLensIntent(restoredIntent, { announce: false, persist: false });
    } else if (!hasDualIntent) {
      applyLensIntent(lensIntent, { announce: false, persist: false });
    }
    updateSummary();
    [350, 900].forEach((delay) => window.setTimeout(() => {
      refreshIntentAvailability();
      updateSummary();
    }, delay));
    [400, 1200, 2500, 5000, 8000].forEach((delay) => window.setTimeout(updateSummary, delay));

    root.__cityColourVisualShell = { product, mediaWrapper, slides, overlay, gallery, navigation, hero, referenceGallery };
    return root.__cityColourVisualShell;
  };

  const classifyDetail = (title, index) => {
    const value = String(title || '').toLowerCase();
    if (/before|after/.test(value)) return ['Before / After', 'Natural eye compared with lens'];
    if (/model|face|wider|natural light/.test(value)) return ['Wider look', 'See the colour at normal distance'];
    if (/box|pack|package|included/.test(value)) return ["What's included", 'Product and packaging'];
    if (index === 0) return ['On eye', 'Selected shade close-up'];
    return [`Shade detail ${index + 1}`, 'Additional verified product image'];
  };

  const updateVisuals = (root, colourName) => {
    const map = readMap(root);
    const generatedMap = readGeneratedMap(root);
    const generated = generatedMap?.[colourName] || null;
    const colour = map?.colours?.find((item) => item.name === colourName);
    const button = shadeButton(root, colourName);
    const shell = ensureVisualShell(root);
    if (!colour || !button || !shell) return;

    const swatchSource = button.dataset.swatchSource || colour.swatch_url || colour.image_url || '';
    const heroSource = button.dataset.imageSource || colour.image_url || '';
    const patternOnly = button.dataset.patternOnly === 'true';
    const compactSource = button.dataset.compactSource === 'true';
    const isolatedPattern = colour.pattern_isolated === true || Boolean(colour.swatch_asset);
    const lens = shell.overlay.querySelector('.city-colour-hero-overlay__lens');
    const lensImage = lens.querySelector('img');
    lens.classList.toggle('is-pattern-only', patternOnly || isolatedPattern);
    lens.classList.toggle('is-compact-source', compactSource);
    lensImage.src = toCdnWidth(swatchSource, 320);
    shell.overlay.querySelector('.city-colour-hero-overlay__label').textContent = colourName;

    const thumbs = Array.from(shell.mediaWrapper.querySelectorAll('.mz-thumb[data-media-id]'));
    const thumbById = new Map(thumbs.map((thumb) => [String(thumb.dataset.mediaId), thumb]));
    const mediaIds = (Array.isArray(colour.media_ids) && colour.media_ids.length ? colour.media_ids : [colour.media_id])
      .filter(Boolean)
      .map(String);
    const entries = [];

    if (heroSource && colour.preview_available !== false) {
      const mappedHeroAlt = String(colour.alt || '').trim();
      const heroAlt = mappedHeroAlt && !/physical\s+(?:contact\s+)?lens|lens\s+pattern/i.test(mappedHeroAlt)
        ? mappedHeroAlt
        : `${colourName} coloured contact lens on eye`;
      entries.push({
        label: 'On eye',
        copy: 'Selected shade close-up',
        src: heroSource,
        alt: heroAlt,
        mediaId: String(colour.media_id || ''),
        showOverlay: true,
        kind: 'on-eye'
      });
    }

    if (swatchSource) {
      entries.push({
        label: 'Lens pattern',
        copy: 'Detailed design and colour',
        src: swatchSource,
        alt: `${colourName} physical contact lens pattern`,
        pattern: true,
        compactSource,
        isolatedPattern,
        kind: 'pattern'
      });
    }

    if (generated?.comparison) {
      entries.push({
        label: 'Colour comparison',
        copy: `Illustrative same eye: natural vs ${colourName}`,
        src: generated.comparison,
        alt: `Illustrative natural eye and ${colourName} contact lens colour comparison`,
        kind: 'comparison'
      });
    } else if (root.dataset.cityBeforeAfter) {
      entries.push({
        label: 'Before / After',
        copy: 'Natural eye compared with lens',
        src: root.dataset.cityBeforeAfter,
        alt: `${colourName} contact lens before and after comparison`,
        kind: 'comparison'
      });
    } else if (!shell.referenceGallery) {
      mediaIds.slice(1).forEach((mediaId, index) => {
        const thumb = thumbById.get(mediaId);
        if (!thumb) return;
        const source = thumb.getAttribute('href') || thumb.dataset.image;
        if (!source || entries.some((entry) => entry.src === source)) return;
        const [label, copy] = classifyDetail(thumb.getAttribute('title'), index + 1);
        entries.push({ label, copy, src: source, alt: thumb.getAttribute('title') || `${colourName} detail`, mediaId });
      });
    }

    if (generated?.wider) {
      entries.push({
        label: 'Wider look',
        copy: 'See the colour at a natural viewing distance',
        src: generated.wider,
        alt: `${colourName} contact lenses shown at a natural viewing distance`,
        kind: 'wider'
      });
    } else if (root.dataset.cityWiderLook) {
      entries.push({
        label: 'Wider look',
        copy: 'See the colour at a natural viewing distance',
        src: root.dataset.cityWiderLook,
        alt: `${colourName} contact lenses shown at a natural viewing distance`,
        kind: 'wider'
      });
    }

    const allShadeIds = new Set((map.colours || []).flatMap((item) => (
      Array.isArray(item.media_ids) && item.media_ids.length ? item.media_ids : [item.media_id]
    )).filter(Boolean).map(String));
    const packagingThumb = thumbs.find((thumb) => /box|pack|package|included/i.test(thumb.getAttribute('title') || ''))
      || thumbs.find((thumb) => !allShadeIds.has(String(thumb.dataset.mediaId || '')));
    if (root.dataset.cityPackagingClean) {
      entries.push({
        label: "What's included",
        copy: 'Product and packaging',
        src: root.dataset.cityPackagingClean,
        alt: 'Contact lens product and packaging on a clean white background',
        kind: 'packaging'
      });
    } else if (packagingThumb) {
      const source = packagingThumb.getAttribute('href') || packagingThumb.dataset.image;
      if (source && !entries.some((entry) => entry.src === source)) {
        entries.push({
          label: "What's included",
          copy: 'Product and packaging',
          src: source,
          alt: packagingThumb.getAttribute('title') || 'Product packaging',
          mediaId: String(packagingThumb.dataset.mediaId || ''),
          kind: 'packaging'
        });
      }
    }

    if (shell.referenceGallery && shell.hero && entries.length) {
      shell.slides.dataset.cityColourEntries = JSON.stringify(entries.map((entry) => ({
        src: entry.src,
        alt: entry.alt || '',
        pattern: Boolean(entry.pattern),
        showOverlay: entry.showOverlay === true,
        kind: entry.kind || 'detail',
        isolatedPattern: Boolean(entry.isolatedPattern),
        compactSource: Boolean(entry.compactSource)
      })));
    }

    shell.gallery.innerHTML = `
      <h2>See ${colourName} in detail</h2>
      <div class="city-colour-detail-gallery__grid"></div>
    `;
    const grid = shell.gallery.querySelector('.city-colour-detail-gallery__grid');
    entries.slice(0, 5).forEach((entry, entryIndex) => {
      const interactive = shell.referenceGallery || Boolean(entry.mediaId);
      const card = document.createElement(interactive ? 'button' : 'div');
      if (interactive) card.type = 'button';
      card.className = `city-colour-detail-card city-colour-detail-card--${entry.kind || 'detail'}${entry.pattern ? ' city-colour-detail-card--pattern' : ''}${entry.isolatedPattern ? ' city-colour-detail-card--isolated-pattern' : ''}${entry.compactSource ? ' city-colour-detail-card--compact-source' : ''}`;
      card.innerHTML = `
        <span class="city-colour-detail-card__media"><img src="${toCdnWidth(entry.src, 480)}" alt="${entry.alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;')}" loading="lazy" decoding="async"></span>
        <span class="city-colour-detail-card__body">
          <strong>${entry.label}</strong>
          <small>${entry.copy}</small>
        </span>
      `;
      if (shell.referenceGallery) {
        card.setAttribute('aria-label', `View ${entry.label}`);
        card.setAttribute('aria-pressed', entryIndex === 0 ? 'true' : 'false');
        card.dataset.cityColourEntryIndex = String(entryIndex);
      } else if (entry.mediaId) {
        card.addEventListener('click', () => thumbById.get(entry.mediaId)?.click());
      }
      grid.appendChild(card);
    });
    root.__cityColourScrollSelected?.(button);
    root.__cityColourUpdateRail?.();
    if (shell.referenceGallery && entries.length) showHeroEntry(shell, 0);
  };

  const mount = (root) => {
    if (!root || root.dataset.cityColourPdpReady === 'true') return;
    const map = readMap(root);
    if (!map?.colours?.length) return;
    root.dataset.cityColourPdpReady = 'true';
    ensureVisualShell(root);
    const selected = root.querySelector('.city-colour-picker__option.is-selected')?.dataset.colourName || map.default_colour || map.colours[0].name;
    [0, 250, 900].forEach((delay) => window.setTimeout(() => updateVisuals(root, selected), delay));
  };

  const mountAll = (scope = document) => scope.querySelectorAll('[data-city-colour-pdp]').forEach(mount);

  const mountFixedPairSummary = (root) => {
    if (!root || root.dataset.cityFixedPairPdpReady === 'true') return;
    const info = root.closest('product-info');
    const product = root.closest('.product');
    const variantPicker = info?.querySelector('variant-selects');
    const packInput = variantPicker?.querySelector('input[type="radio"][name="Size"], input[type="radio"][name="Pack Size"]');
    const packField = packInput?.closest('.product-form__input')
      || Array.from(variantPicker?.querySelectorAll('.product-form__input') || []).find((field) => /^(size|pack size)$/i.test(field.querySelector('legend, .form__label')?.textContent.trim() || ''));
    const packInputs = packField ? Array.from(packField.querySelectorAll('input[type="radio"]')) : [];
    const packValues = [...new Set(packInputs.map((input) => input.value).filter(Boolean))];
    if (!info || !product || !variantPicker || packValues.length !== 1) return;

    const productForm = root.closest('form') || info.querySelector('product-form form');
    const buttons = productForm?.querySelector('.product-form__buttons');
    const leftQuantity = root.querySelector('select[name="properties[Quantity Left]"]');
    const rightQuantity = root.querySelector('select[name="properties[Quantity Right]"]');
    if (!productForm || !buttons || (!leftQuantity && !rightQuantity)) return;
    bindLensParameterFormData(root, productForm);

    root.dataset.cityFixedPairPdpReady = 'true';
    product.classList.add('product--fixed-pair-contact');
    variantPicker.classList.add('city-colour-original-pack--hidden');
    const estimate = info.querySelector('[id^="supply-estimate-"]');
    if (estimate) {
      estimate.hidden = true;
      estimate.setAttribute('aria-hidden', 'true');
    }

    const optionLabel = packField?.querySelector('label')?.innerText?.trim().replace(/\s+/g, ' ') || packValues[0];
    const priceMatch = optionLabel.match(/\$([\d,.]+)/);
    const lensCountMatch = optionLabel.match(/(\d+)\s+lenses?/i);
    let packPrice = priceMatch ? Number(priceMatch[1].replace(/,/g, '')) : 0;
    const lensesPerBox = lensCountMatch ? Number(lensCountMatch[1]) : 2;
    if (!packPrice) {
      try {
        const variants = JSON.parse(variantPicker.querySelector('script[type="application/json"]')?.textContent || '[]');
        packPrice = Number(variants[0]?.price || 0) / 100;
      } catch (error) {
        packPrice = 0;
      }
    }

    let summary = productForm.querySelector('[data-city-fixed-pair-order-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'city-colour-order-summary city-fixed-pair-order-summary';
      summary.dataset.cityFixedPairOrderSummary = '';
      summary.setAttribute('aria-live', 'polite');
      buttons.insertAdjacentElement('beforebegin', summary);
    }

    const samePrescription = root.querySelector('#same');
    const submitButton = productForm.querySelector('[type="submit"]');
    const submitLabel = submitButton?.querySelector('span');
    const uploadSlot = root.querySelector('[data-city-rx-app-upload-slot]');
    const firstIncompleteField = () => Array.from(root.querySelectorAll('[data-city-rx-manual-fields] select[required]:not(:disabled)'))
      .find((field) => !String(field.value || '').trim() || (field.validity && !field.validity.valid)) || null;
    const uploadComplete = () => Boolean(uploadSlot?.querySelector('[data-filepond-item-state="processing-complete"]'))
      || Array.from(productForm.querySelectorAll('input[name*="Prescription Upload"], textarea[name*="Prescription Upload"]'))
        .some((field) => /cloudlift\.app/i.test(String(field.value || '')));
    const prescriptionState = () => {
      const uploadMode = Boolean(uploadSlot?.classList.contains('is-open'));
      if (uploadMode) {
        return {
          complete: uploadComplete(),
          target: uploadSlot.querySelector('.filepond--drop-label label') || uploadSlot.querySelector('input[type="file"]') || uploadSlot
        };
      }
      const target = firstIncompleteField();
      return { complete: !target, target };
    };
    const focusIncomplete = () => {
      const state = prescriptionState();
      if (state.complete || !state.target) return false;
      state.target.setAttribute('aria-invalid', 'true');
      if (!state.target.matches('input, select, textarea, button, a[href], [tabindex]')) state.target.setAttribute('tabindex', '-1');
      state.target.focus?.({ preventScroll: true });
      state.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    };
    const parseMoneyCents = (value) => {
      const numeric = Number(String(value || '').replace(/[^\d.-]/g, ''));
      return Number.isFinite(numeric) && numeric > 0 ? Math.round(numeric * 100) : 0;
    };
    const syncAppstleTotals = (totalBoxes) => {
      if (totalBoxes < 1) return;
      productForm.querySelectorAll('.appstle_subscription_wrapper_option').forEach((option) => {
        const money = option.querySelector('.appstle_subscription_amount .money');
        if (!money) return;
        const raw = parseMoneyCents(money.textContent);
        const rendered = Number(money.dataset.cityClearRenderedTotalCents || 0);
        const cached = Number(money.dataset.cityClearUnitPriceCents || 0);
        const unit = cached > 0 && rendered > 0 && raw === rendered ? cached : raw;
        if (!unit) return;
        const total = unit * totalBoxes;
        option.querySelectorAll('.appstle_subscription_amount .money, .appstle_subscription_amount-appstle-sr-only .money').forEach((node) => {
          node.dataset.cityClearUnitPriceCents = String(unit);
          node.dataset.cityClearRenderedTotalCents = String(total);
          node.textContent = `$${(total / 100).toFixed(2)}`;
        });
      });
    };
    const syncCtas = (totalBoxes, total) => {
      const complete = prescriptionState().complete;
      const text = complete && totalBoxes > 0 ? `Add to cart — $${total.toFixed(2)}` : 'Complete prescription';
      if (submitLabel) submitLabel.textContent = text;
      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
      }
      const sticky = document.querySelector('[data-city-sticky-submit]');
      if (sticky) {
        productForm.dataset.cityClearStickyText = text;
        productForm.dataset.cityClearStickyMode = complete && totalBoxes > 0 ? 'complete' : 'incomplete';
        sticky.textContent = text;
        sticky.dataset.cityStickyRxMode = complete && totalBoxes > 0 ? 'complete' : 'incomplete';
        sticky.classList.toggle('is-secondary', !complete || totalBoxes < 1);
        if (sticky.dataset.cityClearSyncObserverReady !== 'true') {
          sticky.dataset.cityClearSyncObserverReady = 'true';
          new MutationObserver(() => window.queueMicrotask(() => {
            const desired = productForm.dataset.cityClearStickyText || '';
            const mode = productForm.dataset.cityClearStickyMode || 'incomplete';
            if (desired && sticky.textContent.trim() !== desired) sticky.textContent = desired;
            sticky.dataset.cityStickyRxMode = mode;
            sticky.classList.toggle('is-secondary', mode !== 'complete');
          })).observe(sticky, { childList: true, characterData: true, subtree: true });
        }
      }
    };
    const manualValuesMatch = () => {
      const controls = Array.from(root.querySelectorAll('[name^="properties["]'));
      const values = new Map(controls.map((control) => [control.name, String(control.value || '').trim()]));
      return controls
        .filter((control) => / Left\]$/.test(control.name) && !/Quantity Left\]$/.test(control.name))
        .every((leftControl) => {
          const rightName = leftControl.name.replace(/ Left\]$/, ' Right]');
          return !values.has(rightName) || values.get(rightName) === String(leftControl.value || '').trim();
        });
    };

    const update = () => {
      const shared = Boolean(samePrescription?.checked) && manualValuesMatch();
      const leftBoxes = Number(leftQuantity?.value || 0);
      const rightBoxes = Number(rightQuantity?.value || 0);
      const totalBoxes = shared ? leftBoxes : leftBoxes + rightBoxes;
      const totalLenses = totalBoxes * lensesPerBox;
      const total = totalBoxes * packPrice;
      const boxLabel = `${totalBoxes} ${totalBoxes === 1 ? 'box' : 'boxes'}`;
      const replacementLine = (() => {
        if (shared) return `Approx. ${totalBoxes * 6} months supply for both eyes · Six-month replacement`;
        if (leftBoxes > 0 && rightBoxes > 0 && leftBoxes === rightBoxes) return `Approx. ${leftBoxes * 12} months per eye · Six-month replacement`;
        const eyes = [];
        if (leftBoxes > 0) eyes.push(`Left eye ~${leftBoxes * 12} months`);
        if (rightBoxes > 0) eyes.push(`Right eye ~${rightBoxes * 12} months`);
        return eyes.length ? `Approx. supply: ${eyes.join(' · ')} · Six-month replacement` : '';
      })();
      const perLens = packPrice > 0 ? `$${(packPrice / lensesPerBox).toFixed(2)} per lens` : '';
      const parameterLine = parameterSummaryHtml(root);
      summary.innerHTML = totalBoxes > 0
        ? `<span>Order summary</span><strong>${boxLabel} · ${totalLenses} lenses total · $${total.toFixed(2)}</strong>${replacementLine ? `<small>${replacementLine}</small>` : ''}${perLens ? `<small>${perLens}</small>` : ''}${parameterLine}`
        : `<span>Order summary</span><strong>Choose at least one box</strong>${parameterLine}`;
      syncAppstleTotals(totalBoxes);
      syncCtas(totalBoxes, total);
      emitPurchaseSupply(productForm, false);
    };

    [leftQuantity, rightQuantity, samePrescription].filter(Boolean).forEach((control) => control.addEventListener('change', update));
    root.addEventListener('change', (event) => {
      if (event.target.matches('select[name^="properties["]')) window.setTimeout(update, 0);
    });
    submitButton?.addEventListener('click', (event) => {
      if (prescriptionState().complete) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusIncomplete();
    }, true);
    productForm.addEventListener('submit', (event) => {
      if (prescriptionState().complete) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusIncomplete();
    }, true);
    productForm.addEventListener('change', (event) => {
      if (event.target.matches('.appstle_sub_widget input[name="selling_plan"], .appstle_sub_widget select')) {
        [0, 120, 500].forEach((delay) => window.setTimeout(update, delay));
      }
    });
    if (uploadSlot) {
      new MutationObserver(() => window.setTimeout(update, 0)).observe(uploadSlot, {
        attributes: true,
        attributeFilter: ['class', 'data-filepond-item-state', 'value'],
        childList: true,
        subtree: true
      });
    }
    update();
    [250, 900].forEach((delay) => window.setTimeout(update, delay));
  };

  const mountFixedPairSummaries = (scope = document) => scope.querySelectorAll('[data-city-fixed-pair-pdp]').forEach(mountFixedPairSummary);

  const mountClearPdp = (root) => {
    if (!root || root.dataset.cityClearPdpReady === 'true' || root.hasAttribute('data-city-fixed-pair-pdp')) return;
    const info = root.closest('product-info');
    const product = root.closest('.product');
    const productForm = root.closest('form') || info?.querySelector('product-form form');
    const buttons = productForm?.querySelector('.product-form__buttons');
    const variantPicker = info?.querySelector('variant-selects');
    const leftQuantity = root.querySelector('select[name="properties[Quantity Left]"]');
    const rightQuantity = root.querySelector('select[name="properties[Quantity Right]"]');
    if (!info || !product || !productForm || !buttons || (!leftQuantity && !rightQuantity)) return;
    bindLensParameterFormData(root, productForm);

    root.dataset.cityClearPdpReady = 'true';
    product.classList.add('product--clear-contact-purchase');

    const fixedParameters = root.querySelector('[data-city-clear-fixed-parameters]');
    const fixedValues = {
      'Base Curve': fixedParameters?.dataset.cityFixedBaseCurve || '',
      Diameter: fixedParameters?.dataset.cityFixedDiameter || ''
    };
    const syncFixedValues = () => Object.entries(fixedValues).forEach(([key, value]) => {
      if (!value) return;
      ['Left', 'Right'].forEach((side) => {
        const input = root.querySelector(`input[type="hidden"][name="properties[${key} ${side}]"]`);
        if (input && !input.value) {
          input.value = value;
          input.setAttribute('value', value);
        }
      });
    });
    syncFixedValues();

    const estimate = info.querySelector('[id^="supply-estimate-"]');
    if (estimate) {
      estimate.hidden = true;
      estimate.setAttribute('aria-hidden', 'true');
    }

    let summary = productForm.querySelector('[data-city-clear-order-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'city-colour-order-summary city-clear-order-summary';
      summary.dataset.cityClearOrderSummary = '';
      summary.setAttribute('aria-live', 'polite');
      buttons.insertAdjacentElement('beforebegin', summary);
    }

    const placeSummary = () => {
      const customPurchaseOptions = productForm.querySelector('[data-city-contact-purchase-options]:not([hidden])');
      if (customPurchaseOptions) {
        if (summary.previousElementSibling !== customPurchaseOptions) customPurchaseOptions.insertAdjacentElement('afterend', summary);
        return;
      }
      const purchaseOptions = productForm.querySelector('.appstle_sub_widget');
      if (purchaseOptions) {
        if (summary.nextElementSibling !== purchaseOptions) purchaseOptions.insertAdjacentElement('beforebegin', summary);
      } else if (summary.nextElementSibling !== buttons) {
        buttons.insertAdjacentElement('beforebegin', summary);
      }
    };

    const packField = (() => {
      const packInput = variantPicker?.querySelector('input[type="radio"][name="Size"], input[type="radio"][name="Pack Size"]');
      return packInput?.closest('.product-form__input')
        || Array.from(variantPicker?.querySelectorAll('.product-form__input') || []).find((field) => /^(size|pack size)$/i.test(field.querySelector('legend, .form__label')?.textContent.trim() || ''));
    })();
    const packInputs = packField ? Array.from(packField.querySelectorAll('input[type="radio"]')) : [];
    let variants = [];
    try {
      variants = JSON.parse(variantPicker?.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const parseMoneyCents = (value) => {
      const numeric = Number(String(value || '').replace(/[^\d.-]/g, ''));
      return Number.isFinite(numeric) && numeric > 0 ? Math.round(numeric * 100) : 0;
    };
    const appstleOptionUnitPrice = (option) => {
      const money = option?.querySelector('.appstle_subscription_amount .money');
      if (!money) return 0;
      const raw = parseMoneyCents(money.textContent);
      const rendered = Number(money.dataset.cityClearRenderedTotalCents || 0);
      const cached = Number(money.dataset.cityClearUnitPriceCents || 0);
      if (cached > 0 && rendered > 0 && raw === rendered) return cached;
      if (raw > 0) money.dataset.cityClearUnitPriceCents = String(raw);
      delete money.dataset.cityClearRenderedTotalCents;
      return raw;
    };
    const selectedAppstleUnitPrice = () => {
      const selected = productForm.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
      return appstleOptionUnitPrice(selected?.closest('.appstle_subscription_wrapper_option'));
    };
    const selectedPack = () => {
      const input = packInputs.find((candidate) => candidate.checked) || packInputs[0] || null;
      const label = input?.id ? packField?.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      const source = `${input?.value || ''} ${label?.innerText || ''}`.replace(/\s+/g, ' ').trim();
      const variant = variants.find((candidate) => candidate.title === input?.value || candidate.options?.includes(input?.value))
        || variants.find((candidate) => candidate.available)
        || variants[0]
        || null;
      const combined = `${source} ${variant?.title || ''}`;
      const lensMatch = combined.match(/(\d+)\s*(?:lenses?|pack|pk)\b/i) || combined.match(/\b(\d+)\b/);
      return {
        input,
        variant,
        lensesPerBox: lensMatch ? Number(lensMatch[1]) : 0,
        unitPriceCents: selectedAppstleUnitPrice() || Number(variant?.price || 0)
      };
    };

    const wearSchedule = `${root.dataset.cityWearSchedule || ''} ${document.title || ''}`.toLowerCase();
    const daysPerLens = /six[-\s]?month/.test(wearSchedule) ? 180
      : /month/.test(wearSchedule) ? 30
        : /fortnight|2\s*week/.test(wearSchedule) ? 14
          : /week/.test(wearSchedule) ? 7
            : 1;
    const monthLabel = (months) => {
      const rounded = Math.round(Number(months || 0) * 10) / 10;
      if (!rounded) return '';
      const value = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
      return `${value} ${rounded === 1 ? 'month' : 'months'}`;
    };
    const supplyLine = (supply) => {
      if (!supply?.lensesPerBox || !supply?.daysPerLens) return '';
      if (supply.leftBoxes > 0 && supply.rightBoxes > 0 && Math.abs(supply.leftMonths - supply.rightMonths) < .05) {
        return `Approx. ${monthLabel(supply.leftMonths)} per eye`;
      }
      const parts = [];
      if (supply.leftBoxes > 0) parts.push(`Left eye ~${monthLabel(supply.leftMonths)}`);
      if (supply.rightBoxes > 0) parts.push(`Right eye ~${monthLabel(supply.rightMonths)}`);
      return parts.length ? `Approx. supply: ${parts.join(' · ')}` : '';
    };

    const submitButton = productForm.querySelector('[type="submit"]');
    const submitLabel = submitButton?.querySelector('span');
    const uploadSlot = root.querySelector('[data-city-rx-app-upload-slot]');
    const firstIncompleteField = () => Array.from(root.querySelectorAll('[data-city-rx-manual-fields] select[required]:not(:disabled)'))
      .find((field) => !String(field.value || '').trim() || (field.validity && !field.validity.valid)) || null;
    const uploadComplete = () => Boolean(uploadSlot?.querySelector('[data-filepond-item-state="processing-complete"]'))
      || Array.from(productForm.querySelectorAll('input[name*="Prescription Upload"], textarea[name*="Prescription Upload"]'))
        .some((field) => /cloudlift\.app/i.test(String(field.value || '')));
    const prescriptionState = () => {
      const uploadMode = Boolean(uploadSlot?.classList.contains('is-open'));
      if (uploadMode) {
        return {
          complete: uploadComplete(),
          target: uploadSlot.querySelector('.filepond--drop-label label') || uploadSlot.querySelector('input[type="file"]') || uploadSlot
        };
      }
      const target = firstIncompleteField();
      return { complete: !target, target };
    };
    const focusIncomplete = () => {
      const state = prescriptionState();
      if (state.complete || !state.target) return false;
      state.target.setAttribute('aria-invalid', 'true');
      if (!state.target.matches('input, select, textarea, button, a[href], [tabindex]')) state.target.setAttribute('tabindex', '-1');
      state.target.focus?.({ preventScroll: true });
      state.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    };

    const syncAppstleTotals = (totalBoxes) => {
      if (totalBoxes < 1) return;
      productForm.querySelectorAll('.appstle_subscription_wrapper_option').forEach((option) => {
        const unit = appstleOptionUnitPrice(option);
        if (!unit) return;
        const total = unit * totalBoxes;
        option.querySelectorAll('.appstle_subscription_amount .money, .appstle_subscription_amount-appstle-sr-only .money').forEach((money) => {
          money.dataset.cityClearUnitPriceCents = String(unit);
          money.dataset.cityClearRenderedTotalCents = String(total);
          money.textContent = `$${(total / 100).toFixed(2)}`;
        });
      });
    };
    const setCartQuantity = (boxes) => {
      productForm.querySelectorAll('input[name="quantity"]').forEach((input) => {
        input.value = String(boxes);
        input.setAttribute('value', String(boxes));
      });
      productForm.dataset.cityClearTotalBoxes = String(boxes);
    };
    const syncCtas = (complete, total) => {
      const text = complete && total > 0 ? `Add to cart — $${total.toFixed(2)}` : 'Complete prescription';
      if (submitLabel) submitLabel.textContent = text;
      if (submitButton) {
        submitButton.dataset.cityClearPrescriptionComplete = complete ? 'true' : 'false';
        submitButton.removeAttribute('aria-disabled');
      }
      const sticky = document.querySelector('[data-city-sticky-submit]');
      if (sticky) {
        productForm.dataset.cityClearStickyText = text;
        productForm.dataset.cityClearStickyMode = complete && total > 0 ? 'complete' : 'incomplete';
        sticky.textContent = text;
        sticky.dataset.cityStickyRxMode = complete && total > 0 ? 'complete' : 'incomplete';
        sticky.classList.toggle('is-secondary', !complete || total <= 0);
        if (sticky.dataset.cityClearSyncObserverReady !== 'true') {
          sticky.dataset.cityClearSyncObserverReady = 'true';
          new MutationObserver(() => window.queueMicrotask(() => {
            const desired = productForm.dataset.cityClearStickyText || '';
            const mode = productForm.dataset.cityClearStickyMode || 'incomplete';
            if (desired && sticky.textContent.trim() !== desired) sticky.textContent = desired;
            sticky.dataset.cityStickyRxMode = mode;
            sticky.classList.toggle('is-secondary', mode !== 'complete');
          })).observe(sticky, { childList: true, characterData: true, subtree: true });
        }
      }
    };

    let updating = false;
    const update = () => {
      if (updating) return;
      updating = true;
      syncFixedValues();
      placeSummary();
      const pack = selectedPack();
      const leftBoxes = Number(leftQuantity?.value || 0);
      const rightBoxes = Number(rightQuantity?.value || 0);
      const supplyState = purchaseSupplyFromForm(productForm, false) || calculateContactLensSupply({
        lensesPerBox: pack.lensesPerBox,
        daysPerLens,
        daysPerMonth: 30,
        leftBoxes,
        rightBoxes
      });
      const totalBoxes = supplyState.totalBoxes;
      const totalLenses = supplyState.totalLenses;
      const totalCents = totalBoxes * pack.unitPriceCents;
      const total = totalCents / 100;
      const supply = supplyLine(supplyState);
      const perLens = totalLenses > 0 ? `$${(total / totalLenses).toFixed(2)} per lens` : '';
      const boxLabel = `${totalBoxes} ${totalBoxes === 1 ? 'box' : 'boxes'}`;
      const parameterLine = parameterSummaryHtml(root);
      summary.innerHTML = totalBoxes > 0
        ? `<span>Order summary</span><strong>${boxLabel} · ${totalLenses} lenses total · $${total.toFixed(2)}</strong>${supply ? `<small>${supply}</small>` : ''}${perLens ? `<small>${perLens}</small>` : ''}${parameterLine}`
        : `<span>Order summary</span><strong>Choose at least one box</strong>${parameterLine}`;
      productForm.dataset.cityClearCurrentTotal = total.toFixed(2);
      setCartQuantity(totalBoxes);
      syncAppstleTotals(totalBoxes);
      syncCtas(prescriptionState().complete, total);
      productForm.dispatchEvent(new CustomEvent('city:contact-lens-order-state', {
        bubbles: false,
        detail: { ...supplyState, unitPriceCents: pack.unitPriceCents, totalCents, prescriptionComplete: prescriptionState().complete }
      }));
      updating = false;
    };

    if (root.dataset.cityClearListenersReady !== 'true') {
      root.dataset.cityClearListenersReady = 'true';
      root.addEventListener('change', () => [0, 100, 500].forEach((delay) => window.setTimeout(update, delay)));
      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-city-colour-prescription-routes], .city-rx-manual-return')) {
          [0, 100, 500].forEach((delay) => window.setTimeout(update, delay));
        }
      });
      packInputs.forEach((input) => input.addEventListener('change', () => [0, 150, 700].forEach((delay) => window.setTimeout(update, delay))));
      productForm.addEventListener('change', (event) => {
        if (event.target.matches('.appstle_sub_widget input[name="selling_plan"], .appstle_sub_widget select')) {
          [0, 150, 600].forEach((delay) => window.setTimeout(update, delay));
        }
      });
      submitButton?.addEventListener('click', (event) => {
        if (prescriptionState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusIncomplete();
      }, true);
      productForm.addEventListener('submit', (event) => {
        if (prescriptionState().complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusIncomplete();
      }, true);
      productForm.addEventListener('formdata', (event) => {
        event.formData.set('quantity', productForm.dataset.cityClearTotalBoxes || '0');
      });
      if (uploadSlot) {
        new MutationObserver(() => window.setTimeout(update, 0)).observe(uploadSlot, {
          attributes: true,
          attributeFilter: ['class', 'data-filepond-item-state', 'value'],
          childList: true,
          subtree: true
        });
      }
    }
    update();
    [300, 900, 1800, 3500, 6500].forEach((delay) => window.setTimeout(update, delay));
  };

  const mountClearPdps = (scope = document) => scope.querySelectorAll('[data-city-clear-pdp]').forEach(mountClearPdp);

  window.addEventListener('city:colour-preview', (event) => {
    const root = document.querySelector(`[data-city-colour-pdp][data-product-id="${event.detail?.productId}"]`);
    if (root) window.setTimeout(() => updateVisuals(root, event.detail.colourName), 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
    mountAll();
    mountFixedPairSummaries();
    mountClearPdps();
  }, { once: true });
  else {
    mountAll();
    mountFixedPairSummaries();
    mountClearPdps();
  }
  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
    mountFixedPairSummaries(event.target);
    mountClearPdps(event.target);
  });
})();
